function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_8370",
  "data-name": "Group 8370",
  transform: "translate(-178.166 -40.96)"
}, /*#__PURE__*/React.createElement("path", {
  id: "headphonesalt",
  d: "M86.479,80.3H77.213a3.132,3.132,0,0,1-3.089-3.089V46.328a3.132,3.132,0,0,1,3.089-3.089H80.3q0-14.284-7.962-22.586t-22.924-8.3q-14.962,0-22.924,8.3T18.531,43.24H21.62a3.132,3.132,0,0,1,3.089,3.089V77.213A3.132,3.132,0,0,1,21.62,80.3H18.531A12.354,12.354,0,0,0,30.885,92.656h6.177a6.095,6.095,0,0,1,6.177-6.177h6.177a5.976,5.976,0,0,1,4.393,1.784,5.9,5.9,0,0,1,1.784,4.343A6.091,6.091,0,0,1,53.809,97a5.883,5.883,0,0,1-4.393,1.834H30.885A17.865,17.865,0,0,1,17.76,93.428,17.885,17.885,0,0,1,12.354,80.3Q7.24,80.3,3.618,74.9A23.026,23.026,0,0,1,0,61.771a24.859,24.859,0,0,1,1.688-9.266,16.759,16.759,0,0,1,4.489-6.66V43.24A42.269,42.269,0,0,1,9.6,26.446,42.469,42.469,0,0,1,32.62,3.426a42.876,42.876,0,0,1,33.59,0,43.567,43.567,0,0,1,13.8,9.216,43.27,43.27,0,0,1,9.216,13.8,42.417,42.417,0,0,1,3.426,16.8v2.605a16.759,16.759,0,0,1,4.489,6.66,24.86,24.86,0,0,1,1.688,9.266A23.046,23.046,0,0,1,95.215,74.9Q91.6,80.3,86.479,80.3Z",
  transform: "translate(178.166 40.96)"
}), /*#__PURE__*/React.createElement("path", {
  id: "headphonesalt-2",
  "data-name": "headphonesalt",
  d: "M18.531,80.3A12.354,12.354,0,0,0,30.885,92.656h6.177a6.095,6.095,0,0,1,6.177-6.177h6.177a5.976,5.976,0,0,1,4.393,1.784,5.9,5.9,0,0,1,1.784,4.343A6.091,6.091,0,0,1,53.809,97a5.883,5.883,0,0,1-4.393,1.834H30.885A17.865,17.865,0,0,1,17.76,93.428,17.885,17.885,0,0,1,12.354,80.3Z",
  transform: "translate(178.166 40.96)",
  fill: "#ac1ede"
}));

var SvgHeadphones2 = function SvgHeadphones2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98.833,
    height: 98.833,
    viewBox: "0 0 98.833 98.833",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeadphones2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headphones2.34686d5a.svg";
export { ForwardRef as ReactComponent };